module.exports = __webpack_public_path__ + "img/fuwu_dianhua.34621702.svg";